import styled from '@emotion/styled';

export const TimeUnit = styled.span`
    font-family: 'open_sans', sans-serif;
    margin-right: 4px;
`;
